const api = {
  // HeadPortrait: 'https://yueq.com.cn:9204/hjgwebsite/avatar', // 头像图片
  Article: 'https://yueq.com.cn:9200/article', // 文章
  Message: 'https://yueq.com.cn:9204/message', // 留言
  VerrificationCode: 'https://yueq.com.cn:9204/user/sendsms', // 验证码
  Register: 'https://yueq.com.cn:9204/user/register', // 注册
  SignIn: 'https://yueq.com.cn:9204/user/login', // 登录
  GetUser: ' https://yueq.com.cn:9204/user/getUser', // 获取用户信息
  ModifyUser: 'https://yueq.com.cn:9204/user/modifyUser', // 修改用户信息
  VerifyPassword: 'https://yueq.com.cn:9204/user/verifyPassword', // 验证密码
  ModifyPassword: 'https://yueq.com.cn:9204/user/modifyPassword', // 修改密码
  VerificationCode: 'https://yueq.com.cn:9204/user/sendRestsms', // 发送验证码
  VerifySms: 'https://yueq.com.cn:9204/user/verifySms', // 忘记密码——校验短信验证码
  ForgetPassword: 'https://yueq.com.cn:9204/user/forgetPassword' // 忘记密码——修改密码
}

export default api
